import { useQuery } from 'react-query';

import { queryClient, useRequest } from '@frontend/api';
import type { FileSuggestionValue, QueryFunction } from '@frontend/api';

type PartUuid = string;

export type FileAssignmentSuggestion = {
  primaryFile?: FileSuggestionValue[];
  supportingFiles?: FileSuggestionValue[];
};

export type BomFileAssignmentSuggestionsResponse = {
  suggestions: Record<PartUuid, FileAssignmentSuggestion>;
};

export type UseBomFileAssignmentSuggestionsParams = {
  quoteItemId: number;
};

export type BomFileAssignmentSuggestionsQueryKey = [
  'quoteItems',
  number,
  'bomFileAssignmentSuggestions',
];

export const getBomFileAssignmentSuggestionsQueryKey = (
  params: UseBomFileAssignmentSuggestionsParams,
): BomFileAssignmentSuggestionsQueryKey => [
  'quoteItems',
  params.quoteItemId,
  'bomFileAssignmentSuggestions',
];

export const invalidateBomFileAssignmentSuggestionsQuery = (
  params: UseBomFileAssignmentSuggestionsParams,
) => {
  queryClient.invalidateQueries(
    getBomFileAssignmentSuggestionsQueryKey(params),
  );
};

export const useBomFileAssignmentSuggestions: QueryFunction<
  BomFileAssignmentSuggestionsResponse,
  [UseBomFileAssignmentSuggestionsParams],
  BomFileAssignmentSuggestionsQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getBomFileAssignmentSuggestionsQueryKey(params);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(
        `/quotes/items/${params.quoteItemId}/bom_builder_file_assign_suggestions`,
        {
          init: {
            method: 'GET',
            signal,
          },
        },
      ),
  });
};
